import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { DaylitTheme } from '@lendica/theme';

export const MessageCard = ({ children }: { children: ReactNode }) => {
    return (
        <Box
            sx={{
                boxSizing: 'border-box',
                background: DaylitTheme.Palette.Dawn,
                // background: `radial-gradient(106.18% 72.02% at 63.98% 112.38%, rgba(255, 255, 125, 0.05) 0%, rgba(255, 255, 255, 0.25) 71.42%), radial-gradient(44.11% 100.43% at 77.56% 9.58%, rgba(249, 249, 65, 0.4) 0%, rgba(255, 255, 255, 0.25) 69.64%), linear-gradient(135deg, ${DaylitTheme.Palette.Dawn} 51.2%, ${DaylitTheme.Palette.Canvas} 88.88%), ${DaylitTheme.Palette.Dawn};`,
                // background:
                //     'radial-gradient(123.44% 81.5% at 17.55% 0%, rgba(186, 158, 255, 0.10) 0%, rgba(158, 160, 255, 0.00) 100%), linear-gradient(306deg, rgba(163, 168, 214, 0.10) 29.23%, rgba(255, 255, 255, 0.04) 85.45%), #F8F8F9',
                borderRadius: '10px',
                padding: '18px 22px',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                whiteSpace: 'wrap',
                mb: 2,
            }}
        >
            <Typography
                variant="body1"
                sx={{
                    color: DaylitTheme.Palette.Burgundy, //'#282761'
                    fontWeight: 200,
                    fontSize: 26,
                    lineHeight: 1.21,
                }}
            >
                {children}
            </Typography>
        </Box>
    );
};
